import clsx from "clsx";
import * as React from "react";
import { TProductDiscountType } from "./Discount.types";

const Discount: React.FC<TProductDiscountType> = ({
    product,
    percentage,
    className,
    top = true,
    bottom,
    left = true,
    right,
    ...props
}) => {
    if (product.price_info.price < 0 || !product.price_info.has_discount) {
        return null;
    }

    return (
        <div
            className={clsx(className, {
                "tmp-product__discount-batch": !percentage,
                "tmp-product__discount-batch__percentage": percentage,
                "tmp-sticky-top": top,
                "tmp-sticky-bottom": bottom,
                "tmp-sticky-left": left,
                "tmp-sticky-right": right,
            })}
            {...props}
        >
            {percentage ? "-" + product.price_info.savings_percent + "%" : "Tilbud"}
        </div>
    );
};

export default Discount;
